import { styled } from '@volkswagen-onehub/components-core';
import React from 'react';

type ResultsHeaderType = {
    background?: string,
    color?: string
}

const ResultsHeader = styled.div<ResultsHeaderType>`
    margin-top: var(--size-dynamic0050);
    margin-bottom: var(--size-dynamic0100);
    padding: ${props => props.theme.size.static150};
    background-color: #${props => props.background};
    color: #${props => props.color};
`;

interface ResultsHeadlineInterface {
    background: string,
    color: string
}

const ResultsHeadline = (props: React.PropsWithChildren<ResultsHeadlineInterface>) => {
    return (
        <ResultsHeader background={props.background} color={props.color}>
            {props.children}
        </ResultsHeader>
    );
}

export default ResultsHeadline;
